var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative"},[_vm._m(0),_c('div',{},[_c('PremiumSubscribe')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('img',{staticClass:"w-full cust-subscribe-img",attrs:{"src":"https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/subscribe%20page.jpg","alt":"bg"}})])
}]

export { render, staticRenderFns }